<nb-card class="card-box">
    <nb-card-header class="content-header">
        <span class="title__header">{{title | translate}}</span>
        <nb-icon class="close" icon="close-outline" (click)="cancel()"></nb-icon>
    </nb-card-header>
    <nb-card-body class="content-body">
        <app-unavailable-feature [image]="image"
                                 [attention]="attention"
                                 [descriptionTitle]="descriptionTitle"
                                 [descriptionContent]="descriptionContent"
                                 (cancelCallback)='cancel()'>
        </app-unavailable-feature>
    </nb-card-body>
</nb-card>